export default function EmotionalCard() {
  return (
    <div className="emotional-card">
      <span className="emotional-card__emoji">😴</span>
      <div className="emotional-card__content">
        <h3 className="emotional-card__heading">Sleep Easy Tonight</h3>
        <p className="emotional-card__body">
          Every dollar is accounted for - your bills, your savings, your future. No more guesswork, no more stress.
        </p>
      </div>
    </div>
  );
}
